import ErrorPageComponent from './ErrorPageComponent';

function ErrorPage() {
  return <ErrorPageComponent />;
}

export default ErrorPage;
